import { useDeleteCommentMutation } from "@/hooks/use-comment";
import { Button, Flex, Modal, Stack, Text } from "@flpstudio/design-system";

type Props = {
  opened: boolean;
  commentId: string;
  groupId: string;
  onClose?: (confirmed: boolean) => void;
};

export function DeleteConfirmation(props: Props) {
  const { groupId, commentId, opened, onClose } = props;
  const { mutate, isPending } = useDeleteCommentMutation({
    groupId,
    commentId,
  });

  return (
    <Modal
      opened={opened}
      onClose={() => onClose?.(false)}
      title="Delete your comment?"
    >
      <Stack>
        <Text className="text-[color:--mantine-color-gray-7]">
          If deleted, this comment will be permanently removed.
        </Text>
        <Flex className="flex-col lg:flex-row-reverse">
          <Button
            loading={isPending}
            disabled={isPending}
            color="red"
            variant="outline"
            onClick={() => {
              mutate();
              onClose?.(true);
            }}
            className="text-center"
          >
            Delete
          </Button>
          <Button
            disabled={isPending}
            variant="outline"
            className="text-center"
            onClick={() => onClose?.(false)}
          >
            Cancel
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}
